import { Text, Line } from "@react-three/drei";
import { COLORS } from "../../constants/colors";
import useDeviceType from "../hooks/useDeviceType";

const BORDER_COLOR = COLORS.surfaceElements;
const WIDTH = 5.5;
const HEIGHT = 4.5;
const MOBILE_HEIGHT = 3.5; // Меньшая высота для мобильной версии (3 строки вместо 4)

const points = [
  [-WIDTH, 0, -HEIGHT],
  [WIDTH, 0, -HEIGHT],
  [WIDTH, 0, HEIGHT],
  [-WIDTH, 0, HEIGHT],
  [-WIDTH, 0, -HEIGHT], // замыкаем контур
];

const mobilePoints = [
  [-WIDTH, 0, -MOBILE_HEIGHT],
  [WIDTH, 0, -MOBILE_HEIGHT],
  [WIDTH, 0, MOBILE_HEIGHT],
  [-WIDTH, 0, MOBILE_HEIGHT],
  [-WIDTH, 0, -MOBILE_HEIGHT], // замыкаем контур
];

const ExplanationMovement = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
}) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile" || deviceType === "tablet";

  return (
    <group position={position} rotation={rotation}>
      {/* Рамка вокруг инструкций */}
      {isMobile ? (
        <group position={[4.4, 0, 3]}>
          <Line points={mobilePoints} lineWidth={4} dashed={false} />
        </group>
      ) : (
        <group position={[4.4, 0, 3]}>
          <Line points={points} lineWidth={4} dashed={false} />
        </group>
      )}

      {isMobile ? (
        // Мобильная версия
        <>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 1]}
            anchorX="left"
            color="white"
          >
            ◁ △ ▽ ▷ - move 😊
          </Text>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 3]}
            anchorX="left"
            color="white"
          >
            R - reset
          </Text>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 5]}
            anchorX="left"
            color="white"
          >
            GO - start / open
          </Text>
        </>
      ) : (
        // Десктопная версия
        <>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 0]}
            anchorX="left"
            color="white"
          >
            W, A, S, D - move
          </Text>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 2]}
            anchorX="left"
            color="white"
          >
            ◁ △ ▽ ▷ - move too 😊
          </Text>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 4]}
            anchorX="left"
            color="white"
          >
            R - reset
          </Text>
          <Text
            scale={0.8}
            rotation-x={Math.PI / 2}
            rotation-y={Math.PI}
            rotation-z={Math.PI}
            position={[0, 0, 6]}
            anchorX="left"
            color="white"
          >
            ENTER - start / open
          </Text>
        </>
      )}
    </group>
  );
};

export default ExplanationMovement;
